import React from 'react';
import PropTypes from 'prop-types';
import './InfoSection.css';

const InfoSection = ({ title, note = '', columns = 2, altSeparator = false, altTitle = false, items, style }) => {
  const groupedItems = items.reduce((accumulator, item, index) => {
    const groupIndex = Math.floor(index / columns);

    if (!accumulator[groupIndex]) accumulator[groupIndex] = [];

    accumulator[groupIndex].push(item);
    return accumulator;
  }, []);

  return (
    <div className="info-section" style={style}>
      <h5 className={altTitle ? 'info-title-alt' : 'info-title'}>{title}</h5>
      <hr className={altSeparator ? 'info-separator-alt' : 'info-separator'} />
      {note.length > 0 && <p className="info-section-label">{note}</p>}
      <div className="p-2">
        {groupedItems.map((group, groupIndex) => (
          <div className={`row ${groupIndex % 2 === 0 ? 'mb-3' : 'mb-row-odd'}`} key={groupIndex}>
            {group.map((item, itemIndex) => (
              <div
                className={`col-md-${12 / columns} d-flex flex-column justify-content-center`}
                key={itemIndex}
              >
                <div
                  className={`d-flex ${
                    item.alignCenter ? 'align-items-center' : 'align-items-start'
                  } rounded flex-grow-1 ${
                    groupIndex % 2 === 0 ? 'info-item-even' : 'info-item-odd'
                  }`}
                  style={item.style || {}}
                >
                  <label htmlFor={item.labelFor} style={{ width: '40%' }}>
                    {item.label}
                  </label>
                  <div className="info-value" style={{ width: '60%' }}>
                    {item.value}
                  </div>
                </div>
                {groupIndex % 2 !== 0 && <hr className="w-100 mt-auto" />}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

InfoSection.propTypes = {
  title: PropTypes.string.isRequired,
  note: PropTypes.string,
  columns: PropTypes.number,
  altSeparator: PropTypes.bool,
  altTitle: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
      ]).isRequired,
      labelFor: PropTypes.string.isRequired,
      alignCenter: PropTypes.bool,
      style: PropTypes.object,
      value: PropTypes.node.isRequired,
    }),
  ).isRequired,
  style: PropTypes.object,
};

InfoSection.defaultProps = {
  note: '',
  columns: 2,
  altSeparator: false,
  altTitle: false,
  style: {},
};

export default InfoSection;
